import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";

const styles = {
  grid: {
    padding: "0 15px !important",
  },
  treeGrid: {
    padding: "0 15px 0 7px !important",
  },
  noPadding: {
    padding: "0 !important",
  }
};

const useStyles = makeStyles(styles);

export default function GridItem(props) {
  const classes = useStyles();
  const { children, className,xs,sm,md,lg, ...rest } = props;
  let usedclass = classes.grid;
  if (className && className === 'treeGrid')
    usedclass = classes.treeGrid;
  else if (className && className === 'noPadding')
    usedclass = classes.noPadding;
  return (
    <Grid size={{ xs: xs, sm: sm, md: md, lg: lg }} item {...rest} className={usedclass + " " + className}>
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
